import { Color } from "../enums/Color";

export const noData = {
    mobile: {     
        marginTop: "80px",
        fontSize: "20px",
        fontWeight: "bold",
        textAlign: "center",
        color: Color.Black
    },
    desktop: {
        fontSize: "24px"
    }
}